const recommendedShuffle = () => {
    return {
    shuffle() {
        var _this = this;
        var childListItems = this.$refs.list.querySelectorAll('li');
        for (var i = childListItems.length; i >= 0; i--) {
            this.$refs.list.appendChild(childListItems[Math.random() * i | 0]);
        }
        setTimeout(function(){ _this.removeExtras() }, 300);

    },
    removeExtras() {
        console.log('-- remove extras --');
        var childListItems = this.$refs.list.querySelectorAll('li');
        childListItems.forEach(function(el, index) {
                if (index > 3) {
                    el.parentNode.removeChild(el);
                } else {
                console.log(el);
                }
        })
    }
}
}
window.recommendedShuffle = recommendedShuffle;

export default recommendedShuffle;
